import { BONUS_BY_PRODUCT_CARDS_PT_BR } from "#components/bonus-by-product-cards/translations";
import { BONUS_BY_PRODUCT_TABLE_PT_BR } from "#components/tables/reports/bonus-by-product-table/translations";
import { merge } from "lodash-es";

export const financialReport = {
	label: "Fechamento",
	finished: {
		end: "Fechado: {{end}}",
		not: "O evento não foi fechado",
	},
	reportIn: "Faturamento do evento '{{event}}'",
	fileName: "faturamento-{{event}}",
	tabs: {
		bonusByProduct: merge(
			{
				cards: BONUS_BY_PRODUCT_CARDS_PT_BR,
			},
			BONUS_BY_PRODUCT_TABLE_PT_BR,
		),
		bonusReport: {
			title: "Bônus",
			description: "Veja todos os relatórios de concessão e uso de bônus",
			filenameBonus: "bonus-concedido",
			filenameAnticipated: "consumacao-antecipada",
			filenameConsumption: "consumacao",
			total: "Total de {{category}}",
			select: "Selecione uma categoria",
			selectNotFound: "Nenhuma categoria encontrada",
			tabs: {
				given: "Bônus Concedido",
				used: "Bônus Utilizado",
			},
			columns: {
				client: "Funcionário Responsável",
				category: "Categoria",
				date: "Data",
				reason: "Motivo",
				receivedValue: "Recebido",
				spentValue: "Gasto no evento",
				spentValueInOtherEvents: "Gasto em outros eventos",
				givenBy: "Dado por",
				total: "Total",
			},
		},
	},
};
